import NavigationTabBar from './NavigationTabBar';
import NavigationTabItem from './NavigationTabItem';
import { NavigationMenuVisibilityProvider } from './NavigationMenuVisibilityContext';
import { TabBarHeightProvider } from './TabBarHeightContext';
import { Tabs } from 'expo-router';
import { assistanceStackKey, dashboardStackKey, libraryStackKey, healthStackKey as profileStackKey, settingStackKey } from '../../constants/routeKeys';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/useStores';
import { userDrawerLabelPropsKey } from '../../hooks/navigation/useDrawerLabel';

const TabNavigationInner = observer(({state}) => {
  const { user } = useStores();
  const faceScanDisabled = user?.company?.hasAccessToFaceScan === false;
  const allTabKeys: userDrawerLabelPropsKey[] = [
    dashboardStackKey,
    libraryStackKey,
    assistanceStackKey,
    ...(faceScanDisabled ? [] : [profileStackKey]),
    settingStackKey,
  ];

  const activeRouteKey = state.routes[state.index]?.name;
  return (
    <NavigationTabBar tabs={allTabKeys.map(tab => {
      return(<NavigationTabItem key={tab} labelKey={tab} selected={(activeRouteKey === tab)} />);
    })
    } />
  );

});

// NOTE for anyone re-enabling the React Compiler: react-navigation invokes `tabBar`
// as a PLAIN FUNCTION (tabBar(props)), not as a rendered component, so the compiler's
// injected useMemoCache hook throws "Invalid hook call" here. This wrapper then needs
// a 'use no memo' directive.
export const TabNavigation = props => <TabNavigationInner {...props} />;

export const NavigationForSmallScreen = () => {



  return (


    <TabBarHeightProvider>

      <NavigationMenuVisibilityProvider>
        <Tabs
          screenOptions={{
            headerShown:false,
          }}
          tabBar={TabNavigation}

          // Non-tab routes like /session/branching mount as SIBLINGS of the tab
          // screens in this navigator, and the default backBehavior (firstRoute)
          // made goBack() from them land on whichever tab happens to be declared
          // first — (Health). With 'history', goBack() returns to the tab the
          // user actually came from, so finishing a session lands back on the
          // overview that launched it.
          backBehavior="history"
          initialRouteName={dashboardStackKey}
        />
      </NavigationMenuVisibilityProvider>
    </TabBarHeightProvider>

  );
};